import React from "react";

export const SETTING_CONTAINER = "settingContainer";

const REDUCER_HANDLERS = {};

export const initialState = {};

export const source = "NOTIFICATION_SETIINGS_PAGE";

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
